import { MutableRefObject, useEffect, useRef } from 'react'

export const useOutsideClickRef = (callback: (event: MouseEvent) => void): MutableRefObject<HTMLDivElement | null> => {
  const ref: MutableRefObject<HTMLDivElement | null> = useRef(null)

  useEffect(() => {
    const handleClick = (event: MouseEvent): void => {
      if (ref.current && !ref.current.contains(event.target as Node)) {
        callback(event)
      }
    }

    document.addEventListener('click', handleClick)

    return () => {
      document.removeEventListener('click', handleClick)
    }
  }, [callback, ref])

  return ref
}
